import "core-js/modules/es.string.link.js";
import React from 'react';
import Box from 'components/Box';
import Button from 'components/Button';
import Text from 'components/Text';
import { CardLink, Image, Subtitle } from '../shared';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TinyHorizontalCard = function TinyHorizontalCard(_ref) {
  var _ref$isImageLeft = _ref.isImageLeft,
    isImageLeft = _ref$isImageLeft === void 0 ? false : _ref$isImageLeft,
    icon = _ref.icon,
    _ref$imageSource = _ref.imageSource,
    imageSource = _ref$imageSource === void 0 ? '' : _ref$imageSource,
    link = _ref.link,
    title = _ref.title,
    subtitle = _ref.subtitle,
    buttonProps = _ref.buttonProps;
  var imageBox = /*#__PURE__*/_jsx(Box, {
    width: 90,
    background: "shaded",
    children: /*#__PURE__*/_jsx(Image, {
      link: link,
      icon: icon,
      iconScale: 1,
      aspectRatio: 2 / 3,
      src: imageSource
    })
  });
  return /*#__PURE__*/_jsxs(Box, {
    background: "shaded",
    borderRadius: "large",
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    textAlign: "left",
    children: [isImageLeft && imageBox, /*#__PURE__*/_jsxs(Box, {
      grow: true,
      shrink: true,
      px: "s",
      py: 10,
      position: "relative",
      children: [/*#__PURE__*/_jsx(Text, {
        bold: true,
        as: "h3",
        size: "xs",
        lineHeight: 1.4,
        overflow: "wrap",
        children: /*#__PURE__*/_jsx(CardLink, {
          link: link,
          maxLength: 85,
          children: title
        })
      }), subtitle && /*#__PURE__*/_jsx(Subtitle, {
        size: "xxs",
        mt: "xxxs",
        children: subtitle
      })]
    }), !isImageLeft && imageBox, buttonProps && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Button, {
        iconOnly: true,
        icon: buttonProps.icon,
        variant: "transparent",
        size: "small",
        mr: "xs",
        onClick: buttonProps.onClick,
        children: buttonProps.label
      })
    })]
  });
};
TinyHorizontalCard.displayName = 'TinyHorizontalCard';
export default TinyHorizontalCard;